<mat-form-field floatLabel="always" class="mat-border-none float-right">
  <mat-label class="req" [title]="label">
    {{label}}

  </mat-label>
  <div>
    <div #canvas_container class="canvas-container w-100">
      <ng-container
        *ngIf="(form_group.value && form_group.value[form_control]&& form_group.value[form_control][0] && form_group.value[form_control][0].cdnPath)">
        <img id="resumeViewer" frameborder="0" style="width: 100%;height: 100%;object-fit: contain;"
          [src]="(storage_url + (form_group.value && form_group.value[form_control] && form_group.value[form_control][0] && form_group.value[form_control][0].cdnPath)) | SafeFilePipe"
          [title]="form_group.value[form_control][0]['fileName']">
      </ng-container>
    </div>
  </div>
  <div class="text-right mb-2" style="cursor: pointer; font-size: 13px;" *ngIf="!disabled">
    <span class="badge badge-update-status  mr-2" (click)="fileInput.click()"
      [style]="'--background:var(--tallite-green)' | SanitizePipe :'style'">Upload a file</span>
    <span class="badge badge-update-status  mr-2"
      (click)="openSignatureModal(form_group, height, form_control, field, disabled)"
      [style]="'--background:var(--tallite-green)' | SanitizePipe :'style'">E-Signature</span>
    <span class="badge badge-update-status" (click)="clearCanvas()"
      [style]="'--background:var(--js-red);' | SanitizePipe : 'style'"> Clear</span>
  </div>
  <div class="text-center action-taken h-30" [hidden]="!(form_group.value[form_control])">
    <span [hidden]="!(field && field.actionText)">
      {{field.actionText}}
      <span *ngIf="form_group.get(this.field.dateFieldID) && form_group.get(this.field.dateFieldID).value">
        on
        {{form_group.get(this.field.dateFieldID).value | UtcToLocalTime | date: 'dd-MMM-yyyy h:mm a'}}
      </span>

      <span *ngIf="form_group.get(this.field.placeFieldID) && form_group.get(this.field.placeFieldID).value">
        from
        {{form_group.get(this.field.placeFieldID).value}}
      </span>

      <span *ngIf="form_group.get(this.field.ipFieldID) && form_group.get(this.field.ipFieldID).value">
        on the device having IP {{form_group.get(this.field.ipFieldID).value}}
      </span>
    </span>
  </div>


  <input matInput class="d-none" type="text">
</mat-form-field>


<input #fileInput [accept]="'image/png, image/jpeg'" [readonly]="disabled" [disabled]="disabled? true :false"
  (change)="fileInputChanged($event.target.files)" id="input-file{{id}}" type="file" [multiple]="0"
  style="display:none;">